export const REDESIGN_ROOT_PATH = '/n'
export const PAGE_TITLE_SUFFIX = '- Partner Portal'
